import { inject, injectable } from 'tsyringe';
import { ICache } from '../../Cache';
import { ApiInjectToken, MiddlewareInjectToken } from '../../constants/tokens';
import { Apis, MiddlewareConfig } from '../../types';
import { AccountApi } from '../AccountApi';
import { BranchApi } from '../BranchApi';
import { GroupApi } from '../GroupApi';
import { ModelApi } from '../ModelApi';
import { QuoteApi } from '../QuoteApi';
import { TipranksApi } from '../TipranksApi';
import { UserApi } from '../UserApi';

@injectable()
export class AxosAccountApi extends AccountApi {
    constructor(
        @inject(MiddlewareInjectToken.Apis) apis: Apis,
        @inject(MiddlewareInjectToken.Config) config: MiddlewareConfig,
        @inject(MiddlewareInjectToken.Cache) cache: ICache,
        @inject(ApiInjectToken.BranchApi) protected override readonly branchApi: BranchApi,
        @inject(ApiInjectToken.ModelApi) protected override readonly modelApi: ModelApi,
        @inject(ApiInjectToken.GroupApi) protected override readonly groupApi: GroupApi,
        @inject(ApiInjectToken.QuoteApi) protected override readonly quoteApi: QuoteApi,
        @inject(ApiInjectToken.UserApi) protected override readonly userApi: UserApi,
        @inject(ApiInjectToken.TipranksApi) protected override readonly tipranksApi: TipranksApi,
    ) {
        super(apis, config, cache, branchApi, modelApi, groupApi, quoteApi, userApi, tipranksApi);
    }

    async getAccountDocumentsSsoLink(accountNumber: string): Promise<string> {
        const response = await this.apis.middleware.getApiClient().get<{ url: string }>('v1/axos/_/documents', {
            params: { accountNumber },
        });
        return response.data.url;
    }
}
